import { render, staticRenderFns } from "./AdminAttachmentsDownload.vue?vue&type=template&id=218d2acc"
import script from "./AdminAttachmentsDownload.vue?vue&type=script&lang=js"
export * from "./AdminAttachmentsDownload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports